var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGroupChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icGroupChat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M509.835752,453.66 C508.650206,453.66 507.680181,452.787642 507.68,451.721301 L507.68,450.758537 C507.68,449.692358 508.650206,448.82 509.835752,448.82 L510.364248,448.82 C511.549975,448.82 512.52,449.692358 512.52,450.758537 L512.52,451.721301 C512.52,452.787642 511.549794,453.66 510.364248,453.66 L509.835752,453.66 Z M517.267707,452.34 C515.866607,452.34 514.720214,451.309032 514.72,450.04881 L514.72,448.910998 C514.72,447.650968 515.866607,446.62 517.267707,446.62 L517.892293,446.62 C519.293607,446.62 520.44,447.650968 520.44,448.910998 L520.44,450.04881 C520.44,451.309032 519.293393,452.34 517.892293,452.34 L517.267707,452.34 Z M512.614334,454.638202 C512.278625,455.036515 512.08,455.52853 512.08,456.060386 L512.08,459.38 L506.478161,459.38 C506.16987,459.38 505.92,459.139388 505.92,458.842519 L505.92,456.300283 C505.92,455.329671 506.740054,454.54 507.747858,454.54 L512.011833,454.54 C512.222837,454.54 512.425602,454.574595 512.614334,454.638202 Z M520.067139,453.66 C521.24327,453.66 522.2,454.736824 522.2,456.060386 L522.2,459.527071 C522.2,459.931893 521.908485,460.26 521.548812,460.26 L513.611188,460.26 C513.251515,460.26 512.96,459.931893 512.96,459.527071 L512.96,456.060386 C512.96,454.736824 513.91673,453.66 515.092501,453.66 L520.067139,453.66 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Chatrooms-V2",
    transform: "translate(-505.000000, -446.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icGroupChat",
    fill: "#838383",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroupChat);
export default __webpack_public_path__ + "static/media/icGroupChat.4b18359445b2865bc57336f09f99d1d9.svg";
export { ForwardRef as ReactComponent };